<template>
  <div class="link-we-box container">
    <AnimeTitle :title="$t('linkWe.title')" />
    <div
      class="secondary-title"
      data-animation="fade-scale-up"
      data-once="false"
    >
      {{ $t('linkWe.subTitle') }}
    </div>
    <div class="contact-us">
      <div class="contact-us-left">
        <div
          class="contact-us-left-item"
          v-for="(item, index) in infoList"
          :key="index"
          data-animation="fade-scale-up"
          data-once="false"
        >
          <div class="contact-us-left-item-icon">
            <img :src="item.icon" />
            {{ item.title }}
          </div>
          <div class="contact-us-left-item-user">{{ item.userName }}</div>
          <div class="contact-us-left-item-phone">
            <span>{{ $t('linkWe.txtPhone') }}</span
            >{{ item.phone }}
          </div>
          <div class="contact-us-left-item-phone">
            <span>{{ $t('linkWe.txtEmail') }}</span>
            <div>
              <div
                class="contact-us-left-item-email"
                v-for="(element, elementIndex) in item.email"
                :key="elementIndex"
              >
                {{ element }}<br />
              </div>
            </div>
          </div>
          <div
            class="contact-us-dashed"
            v-if="index < infoList.length - 1"
          ></div>
        </div>
      </div>
      <div class="contact-us-right">
        <!-- <div
          class="contact-us-right-title"
          data-animation="fade-scale-up"
          data-once="false"
        >
          {{ $t('linkWe.rightTitle') }}
        </div> -->
        <AnimeTitle
          :title="$t('linkWe.rightTitle')"
          :computingTitle="$t('linkWe.computingTitle')"
          class="contact-us-right-title"
          data-animation="fade-scale-up"
          data-once="false"
        />
        <el-form
          label-position="top"
          class="form-box"
          :model="submitInfo"
          ref="rulesForm"
          :rules="rules"
          require-asterisk-position="right"
          :validate-on-rule-change="false"
        >
          <el-form-item
            data-animation="fade-scale-up"
            data-once="false"
            prop="userName"
            :label="$t('linkWe.formName')"
            class="label-right-required"
          >
            <el-input
              v-model="submitInfo.userName"
              class="input-width"
              :placeholder="$t('linkWe.formNamePlaceholder')"
              @input="clearFieldValidate('userName')"
              @focus="clearFieldValidate('userName')"
              :validate-event="false"
            />
          </el-form-item>
          <el-form-item
            data-animation="fade-scale-up"
            data-once="false"
            prop="mobile"
            :label="$t('linkWe.formPhone')"
            class="label-right-required"
          >
            <el-input
              v-model="submitInfo.mobile"
              class="input-width"
              :placeholder="$t('linkWe.formPhonePlaceholder')"
              @input="clearFieldValidate('mobile')"
              @focus="clearFieldValidate('mobile')"
              :validate-event="false"
            />
          </el-form-item>
          <el-form-item
            data-animation="fade-scale-up"
            data-once="false"
            prop="company"
            :label="$t('linkWe.formPosition')"
            class="label-right-required"
          >
            <el-input
              v-model="submitInfo.company"
              class="input-width"
              :placeholder="$t('linkWe.formPositionPlaceholder')"
              @input="clearFieldValidate('company')"
              @focus="clearFieldValidate('company')"
              :validate-event="false"
            />
          </el-form-item>
          <el-form-item
            data-animation="fade-scale-up"
            data-once="false"
            :label="$t('linkWe.formInterest')"
            class="label-right-required"
            prop="business"
          >
            <el-select
              v-model="submitInfo.business"
              :placeholder="$t('linkWe.formInterestPlaceholder')"
              @change="clearFieldValidate('business')"
              :validate-event="false"
            >
              <el-option
                v-for="item in options"
                :key="item.code"
                :label="currentLocale === 'zh' ? item.name : item.englishName"
                :value="item.code"
              />
            </el-select>
            <!-- <el-input
              v-model="submitInfo.name"
              class="input-width"
              :placeholder="$t('linkWe.formInterestPlaceholder')"
            /> -->
          </el-form-item>
          <el-form-item
            data-animation="fade-scale-up"
            data-once="false"
            prop="content"
            :label="$t('linkWe.formMessage')"
            class="label-right-required full-width-item"
          >
            <el-input
              v-model="submitInfo.content"
              class="input-width"
              type="textarea"
              maxlength="150"
              show-word-limit
              :autosize="{ minRows: 2, maxRows: 4 }"
              :placeholder="$t('linkWe.formMessagePlaceholder')"
              @input="clearFieldValidate('content')"
              @focus="clearFieldValidate('content')"
              :validate-event="false"
            />
          </el-form-item>
        </el-form>
        <div
          class="submit-btn"
          data-animation="fade-scale-up"
          data-once="false"
          @click="submit()"
        >
          {{ $t('linkWe.btnText') }} <img src="@/assets/img/pc/submit.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { submitContactUsInfo, getBusinessesList } from '@/api/api';
import { ElMessage } from 'element-plus';
export default {
  components: {},
  computed: {
    infoList() {
      return [
        {
          icon: require('@/assets/img/pc/contact-us-left1.png'),
          title: this.$t('linkWe.infoList.item1.title'),
          userName: this.$t('linkWe.infoList.item1.userName'),
          phone: this.$t('linkWe.infoList.item1.phone'),
          email: ['hufeiyu@linkwise.tech'],
        },
        {
          icon: require('@/assets/img/pc/contact-us-left2.png'),
          title: this.$t('linkWe.infoList.item2.title'),
          userName: this.$t('linkWe.infoList.item2.userName'),
          phone: this.$t('linkWe.infoList.item2.phone'),
          email: ['zhoudongxia@linkwise.tech'],
        },
        {
          icon: require('@/assets/img/pc/contact-us-left3.png'),
          title: this.$t('linkWe.infoList.item3.title'),
          userName: this.$t('linkWe.infoList.item3.userName'),
          phone: this.$t('linkWe.infoList.item3.phone'),
          email: ['gengyao@linkwise.tech'],
        },
      ];
    },
    rules() {
      return {
        userName: [
          {
            required: true,
            message: this.$t('linkWe.formNamePlaceholder'),
            // trigger: 'blur',
          },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        mobile: [
          {
            required: true,
            message: this.$t('linkWe.formPhonePlaceholder'),
            // trigger: 'blur',
          },
        ],
        business: [
          {
            required: true,
            message: this.$t('linkWe.formInterestPlaceholder'),
            // trigger: 'change',
            // type: 'array',
          },
        ],
        company: [
          {
            required: true,
            message: this.$t('linkWe.formPositionPlaceholder'),
            // trigger: 'blur',
          },
        ],

        content: [
          {
            required: true,
            message: this.$t('linkWe.formMessagePlaceholder'),
            // trigger: 'blur',
          },
        ],
      };
    },
  },
  data() {
    return {
      submitInfo: {
        userName: '',
        mobile: '',
        business: '',
        company: '',
        content: '',
      },
      options: [],
      hasSubmitted: false,
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    '$i18n.locale'() {
      // 语言切换时，只刷新已显示为错误的字段提示，不新增其它提示
      const form = this.$refs.rulesForm;
      if (!form) return;
      this.$nextTick(() => {
        const fields = Array.isArray(form.fields)
          ? form.fields
          : Array.from(form.fields || []);
        const erroredProps = [];
        fields.forEach((field) => {
          try {
            if (field && field.prop && field.validateState === 'error') {
              erroredProps.push(field.prop);
            }
          } catch (e) {}
        });
        if (erroredProps.length) {
          form.validateField(erroredProps, () => {});
        }
      });
    },
  },
  methods: {
    getList() {
      getBusinessesList().then((res) => {
        if (res.responseCode === 200) {
          this.options = res.body;
        }
      });
    },

    submit() {
      this.$refs.rulesForm.validate((valid) => {
        if (valid) {
          submitContactUsInfo(this.submitInfo).then((res) => {
            if (res.responseCode === 200) {
              this.submitInfo = {
                userName: '',
                mobile: '',
                business: '',
                company: '',
                content: '',
              };
              ElMessage.success(this.$t('linkWe.submitSuc'));
              this.$refs.rulesForm.clearValidate();
              this.hasSubmitted = false;
            } else {
              ElMessage.error(res.responseMsg);
            }
          });
        } else {
          this.hasSubmitted = true;
          console.log('error submit!!');
          return false;
        }
      });
    },

    clearFieldValidate(prop) {
      if (this.$refs.rulesForm) {
        this.$refs.rulesForm.clearValidate([prop]);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.link-we-box {
  padding: 120px 0;
  text-align: center;
  .contact-us {
    margin-top: 60px;
    background: #f4f5f7;
    border-radius: 20px;
    display: flex;
    height: 571px;
    width: 100%;
    .contact-us-left {
      width: 520px;
      background: url('@/assets/img/pc/contact-us-bg.png') no-repeat;
      background-size: 100% 100%;
      //   padding-left: 80px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      color: white;
      text-align: left;
      .contact-us-left-item {
        //设置虚线
        // width: 100%;
        // margin: 0 80px;
        margin-left: 80px;
        width: 360px;
      }
      .contact-us-dashed {
        border-bottom: 1px dashed #ffffff;
        margin: 20px 0;
        opacity: 0.3;
        width: 100%;
      }
      //   align-items: center;
      .contact-us-left-item-icon {
        font-size: 24px;
        color: #ffffff;
        line-height: 32px;
        font-family: 'MiSans-Medium';
        display: flex;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      }
      .contact-us-left-item-user {
        font-size: 18px;
        color: #ffffff;
        line-height: 24px;
        margin-top: 14px;
        font-family: 'MiSans-Demibold';
      }
      .contact-us-left-item-phone {
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
        margin-top: 4px;
        display: flex;
        font-weight: 500;
        span {
          font-size: 14px;
          color: #ffffff;
          line-height: 24px;
          display: inline-block;
          margin-right: 24px;
          font-weight: 400;
        }
      }
    }
    .contact-us-right {
      flex: 1;
      display: flex;
      //   justify-content: center;
      // background: black;

      padding: 50px 80px 0 80px;
      flex-direction: column;

      .contact-us-right-title {
        font-weight: 600;
        font-size: 24px;
        margin-bottom: 40px;
        color: #222226;
        line-height: 32px;
        font-family: 'MiSans-Demibold';
      }
      .form-box {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        column-gap: 20px;
        row-gap: 20px;

        // 最后一个表单项撑满全行
        .full-width-item {
          grid-column: 1 / -1;

          .input-width {
            width: 100%;
          }
        }
      }
      .submit-btn {
        width: 100%;
        height: 50px;
        margin-top: 40px;
        background: var(--button-background-color);
        border-radius: 25px;
        color: white;
        font-size: 16px;
        color: #ffffff;
        line-height: 50px;
        text-align: center;
        font-weight: 500;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background: var(--button-hover-color);
        }
        img {
          width: 15px;
          height: 15px;
          margin-left: 5px;
        }
      }
    }
  }
}
.label-right-required :deep(.el-form-item__label::after) {
  content: '*';
  color: red;
  margin-left: 4px;
}

/* 隐藏默认的星号 */
.label-right-required :deep(.el-form-item__label::before) {
  content: none;
}
::v-deep .el-form-item__label {
  font-weight: 400;
  font-size: 14px;
  color: #3d3d40;
  line-height: 24px !important;
  margin-bottom: 5px !important;
}
::v-deep .el-input__wrapper {
  border-radius: 10px;
  font-size: 16px;
  border-radius: 10px;
  height: 46px;
  color: #aaaab3;
  position: relative;
  overflow: visible;
}
::v-deep .el-form-item {
  margin-bottom: 0px;
}
::v-deep .el-textarea__inner {
  border-radius: 10px;
  font-size: 16px;
  padding: 10px;
  // color: #aaaab3;
  resize: none;
}
::v-deep .el-select__wrapper {
  border-radius: 10px;
  font-size: 16px;
  color: #aaaab3;
  border-radius: 10px;
  height: 46px;
}
::v-deep .el-form-item__error {
  margin-top: 4px;
}

/* 设置 el-input 默认状态 - 1px 边框 */
.link-we-box :deep(.el-input__wrapper) {
  border: 1px solid #dcdfe6 !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
  padding: 0 11px !important; /* 默认内边距 */
}

/* 边框进入动画的伪元素（默认在外侧10px且透明） */
.link-we-box :deep(.el-input__wrapper::after) {
  content: '';
  position: absolute;
  top: -10px;
  right: -10px;
  bottom: -10px;
  left: -10px;
  border: 3px solid #0d72ff;
  border-radius: 10px;
  opacity: 0;
  pointer-events: none;
  transition: none;
}

/* 设置 el-input 被选中时的边框颜色 - 2px 边框 */

/* is-focus 时触发伪元素从外向内收并淡入 */
.link-we-box :deep(.el-input__wrapper.is-focus::after) {
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  opacity: 1;
  border-radius: calc(10px + 1px);
  transition: top 0.2s ease, right 0.2s ease, bottom 0.2s ease, left 0.2s ease,
    opacity 0.2s ease;
}

/* 设置 el-textarea 默认状态 */
.link-we-box :deep(.el-textarea__inner) {
  border: 1px solid #dcdfe6 !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
}

/* 为 textarea 容器提供定位以承载动画边框 */
.link-we-box :deep(.el-textarea) {
  position: relative;
  overflow: visible;
}

/* 文本域边框进入动画的伪元素（默认在外侧10px且透明） */
.link-we-box :deep(.el-textarea::after) {
  content: '';
  position: absolute;
  top: -10px;
  right: -10px;
  bottom: -10px;
  left: -10px;
  border: 3px solid #0d72ff;
  border-radius: 10px;
  opacity: 0;
  pointer-events: none;
  transition: none;
}

/* 设置 el-textarea 被选中时的边框（本体透明，动画由伪元素承担） */
.link-we-box :deep(.el-textarea__inner:focus) {
  border: 2px solid transparent !important;
  box-shadow: none !important;
}

/* focus 时触发伪元素从外向内收并淡入（不做反向动画） */
.link-we-box :deep(.el-textarea:focus-within::after) {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 1;
  transition: top 0.2s ease, right 0.2s ease, bottom 0.2s ease, left 0.2s ease,
    opacity 0.2s ease;
}

/* 设置 el-select 默认状态 */
.link-we-box :deep(.el-select__wrapper) {
  border: 1px solid #dcdfe6 !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
  padding: 0 11px !important;
}

/* 设置 el-select 被选中时的边框 */
.link-we-box :deep(.el-select__wrapper.is-focus) {
  border: 2px solid #0d72ff !important;
  box-shadow: 0 0 0 2px #0d72ff !important;
  padding: 0 10px !important;
}

/* 注意：el-option 下拉列表样式已在 main.js 中全局设置 */
</style>
